export const bloghome = 
[{
     
    alt:"An Illustration Banner of a Woman Exploring our Expert Blogs on Corporate Gifts and Uniforms.   ",
    alt2:"An Illustration of a Woman Exploring our Expert Blogs on Corporate Gifts and Uniforms."
}]